export const AUTH = {
  images: {
    login: "assets/img/auth/login.png",
    recover: "assets/img/auth/forgot.png",
    lock: "assets/img/auth/lock.png",
  },
};
